import { VStack, Text, Center, Flex, Box } from '@chakra-ui/react'
import Page from '../../components/Page'
import { Logo } from '../../components/shared-components/Logo'
import { FiCheckCircle } from 'react-icons/fi'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { routes } from '../routes'

export function OrganizationJoinResponsePage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { organizationName, hpio } = (location.state || {}) as {
    organizationName: string
    hpio: string
  }

  useEffect(() => {
    if (!organizationName || !hpio) {
      navigate(routes.selectRoles.path)
    }
  }, [organizationName, hpio, navigate])

  return (
    <Page alignItems="center" containerProps={{ height: '100%' }}>
      <VStack height="100%" spacing="12" maxWidth="700px" width="100%" p="24px">
        <Center>
          <Logo maxWidth={150} />
        </Center>
        <Flex
          direction="column"
          gap="6"
          shadow="2xl"
          borderRadius="md"
          p="12"
          mt="12"
          width="80%"
          align="center"
          textAlign="center"
        >
          <Box color="customBlue.100" bg="blue.50" borderRadius="full" p="4" w={24} h={24}>
            <FiCheckCircle />
          </Box>
          <Text as="h2" fontSize="2xl" fontWeight="bold">
            Organisation joining request submitted
          </Text>
          <Text>
            Your request to join "{hpio} ({organizationName})" has been submitted to the owner of
            the organisation.
          </Text>
          <Text>
            Once the owner approves of your request, you will receive an email from your
            organisation owner inviting you to log in to your RxPad account.
          </Text>
          <Text as="i">You may now exit this screen.</Text>
        </Flex>
      </VStack>
    </Page>
  )
}

export default OrganizationJoinResponsePage
